"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _atlAnalytics = require("./atl-analytics");
Object.keys(_atlAnalytics).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _atlAnalytics[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _atlAnalytics[key];
    }
  });
});
var _communityAnalytics = require("./community-analytics");
Object.keys(_communityAnalytics).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _communityAnalytics[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _communityAnalytics[key];
    }
  });
});